import { useState } from "react";
import { Link } from "react-router-dom";
import { Bookmark, BookmarkCheck, Star } from "lucide-react";
import { toast } from "sonner";
import { isInWatchlist, toggleWatchlist } from "@/lib/api";

export const MoviePoster = ({ movie, className = "" }) => {
  const [imgOk, setImgOk] = useState(Boolean(movie.image));
  const [c1, c2] = movie.palette || ["#2a2019", "#7d1a1a"];
  return (
    <div className={`relative w-full h-full ${className}`} style={{ background: `linear-gradient(155deg, ${c1} 0%, ${c2} 100%)` }}>
      {imgOk && (
        <img src={movie.image} alt={movie.title} loading="lazy" onError={() => setImgOk(false)} className="absolute inset-0 w-full h-full object-cover" />
      )}
      <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(15,10,8,0.88) 0%, rgba(15,10,8,0.15) 55%, rgba(15,10,8,0.25) 100%)" }} />
      {!imgOk && (
        <div className="absolute inset-x-0 top-0 p-4">
          <p className="font-mono-label text-[9px] tracking-[0.3em] uppercase text-[#f6f1e7]/60">{movie.country}</p>
          <p className="font-display font-bold text-2xl leading-tight text-[#f6f1e7] mt-2">{movie.title}</p>
          <p className="font-script text-lg text-[#f6f1e7]/70 mt-1">{movie.original_title !== movie.title ? movie.original_title : ""}</p>
        </div>
      )}
    </div>
  );
};

export const MovieCard = ({ movie }) => {
  const [saved, setSaved] = useState(isInWatchlist(movie.id));

  const onToggle = (e) => {
    e.preventDefault();
    const added = toggleWatchlist(movie);
    setSaved(added);
    toast(added ? `Added "${movie.title}" to your watchlist` : `Removed "${movie.title}" from your watchlist`);
  };

  return (
    <Link to={`/movie/${movie.id}`} data-testid={`movie-card-${movie.id}`} className="poster-card block bg-[#171210] group">
      <div className="aspect-[3/4] relative overflow-hidden">
        <MoviePoster movie={movie} />
        <button
          data-testid={`watchlist-toggle-${movie.id}`}
          onClick={onToggle}
          aria-label="Toggle watchlist"
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-[#0f0a08]/70 backdrop-blur flex items-center justify-center text-[#f6f1e7] hover:bg-[#7d1a1a] transition-colors"
        >
          {saved ? <BookmarkCheck className="w-4 h-4 text-[#e8b96a]" /> : <Bookmark className="w-4 h-4" />}
        </button>
        <div className="absolute bottom-0 inset-x-0 p-4">
          <div className="flex items-center gap-1.5 mb-1">
            <Star className="w-3.5 h-3.5 text-[#e8b96a] fill-[#e8b96a]" />
            <span className="font-mono-label text-xs text-[#e8b96a]">{movie.rating?.toFixed(1)}</span>
          </div>
          <h3 className="font-display font-semibold text-lg leading-snug text-[#f6f1e7]">{movie.title}</h3>
          <p className="font-mono-label text-[10px] tracking-[0.18em] uppercase text-[#d6cebf]/80 mt-1">
            {movie.genres?.[0]} &nbsp;|&nbsp; {movie.country} &nbsp;|&nbsp; {movie.year}
          </p>
        </div>
      </div>
    </Link>
  );
};
